import { useCallback } from 'react';
import { ModalParams } from '~/types';
import { useModalStore } from '~/store';

const useModal = () => {
  const setModalState = useModalStore((state) => state.setModalState);

  const openModal = useCallback(
    ({
      title,
      content,
      type,
      click,
      cancelClick,
      buttonName,
      leftButtonName,
    }: ModalParams) => {
      setModalState({
        isOpen: true,
        title,
        content,
        type: type ? type : 'double_red',
        click,
        cancelClick,
        buttonName,
        leftButtonName,
      });
    },
    [setModalState],
  );

  const closeModal = useCallback(() => {
    setModalState({
      isOpen: false,
      title: '',
      content: '',
      buttonName: '',
      leftButtonName: '',
    });
  }, [setModalState]);

  return { openModal, closeModal };
};

export default useModal;
